import React from "react";
import { useParams, NavLink } from "react-router-dom";
import { FiCheck } from "react-icons/fi";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RequestQuote from "../components/RequestQuote";

import { caseStudiesData } from "../data/caseStudiesData";
import { caseStudyImages } from "../data/caseStudyImages";

import "../assets/css/CaseStudyDetails.css";

const CaseStudyDetails = () => {
  const { slug } = useParams();

  const study = caseStudiesData.find(
    (item) => item.slug === slug
  );

  if (!study) {
    return (
      <>
        <Navbar />

        <div className="case-detail-not-found">
          <h1>Case Study Not Found</h1>
          <NavLink to="/case-detail-studies">
            Back to Case Studies
          </NavLink>
        </div>

        <Footer />
      </>
    );
  }

  const isWhyOutcessCase =
    study.whyOutcess &&
    study.whyOutcess.length > 0;

  return (
    <>
      <Navbar />

      <div className="case-detail-study-page">
        {/* HERO */}

        <section className="case-detail-hero">
          <div className="case-detail-container  container">
            <div className="case-detail-hero-grid">
              <div className="case-detail-image-wrap">
                <img
                  src={caseStudyImages[study.image]}
                  alt={study.title}
                />
              </div>

              <div className="case-detail-hero-content">
                <h1>
                  {study.heroTitle || study.title}
                </h1>

                <p>
                  {study.heroDescription}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CONTENT */}

        <section className="case-detail-content">
          <div className="case-detail-container  container">

            {study.sections?.map((section, index) => (
              <div
                className="case-detail-section"
                key={index}
              >
                <div className="case-detail-section-title">
                  <h2>{section.title}</h2>
                </div>

                <div className="case-detail-section-content">

                  {section.introduction && (
                    <p className="section-intro">
                      {section.introduction}
                    </p>
                  )}

                  {section.paragraphs?.map(
                    (paragraph, idx) => (
                      <p key={idx}>
                        {paragraph}
                      </p>
                    )
                  )}

                  {section.bullets?.length > 0 && (
                    <ul>
                      {section.bullets.map(
                        (bullet, idx) => (
                          <li key={idx}>
                            {bullet}
                          </li>
                        )
                      )}
                    </ul>
                  )}

                  {section.blocks?.length > 0 &&
                    section.blocks.map(
                      (block, idx) => (
                        <div
                          className="case-detail-block"
                          key={idx}
                        >
                          <h3>
                            {block.title}
                          </h3>

                          {block.paragraphs?.map(
                            (paragraph, pIdx) => (
                              <p key={pIdx}>
                                {paragraph}
                              </p>
                            )
                          )}

                          {block.bullets?.length >
                            0 && (
                              <ul>
                                {block.bullets.map(
                                  (
                                    bullet,
                                    bulletIdx
                                  ) => (
                                    <li
                                      key={
                                        bulletIdx
                                      }
                                    >
                                      {bullet}
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                        </div>
                      )
                    )}

                  {section.outcomes?.length >
                    0 && (
                      <ul className="outcomes-list">
                        {section.outcomes.map(
                          (
                            outcome,
                            outcomeIndex
                          ) => (
                            <li
                              key={outcomeIndex}
                            >
                              <strong>
                                {outcome.title}
                              </strong>
                              :{" "}
                              {
                                outcome.description
                              }
                            </li>
                          )
                        )}
                      </ul>
                    )}
                </div>
              </div>
            ))}

          </div>
        </section>

        {/* WHY OUTCESS */}

        {isWhyOutcessCase && (
          <section className="why-outcess-detail">
            <div className="case-detail-container container ">

              <div className="case-detail-content">
                <div className="section-tag">
                  WHY OUTCESS
                </div>
                <div className=" why-list">
                  {study.whyOutcess.map(
                    (item, index) => (
                      <div
                        key={index}
                        className="why-item"
                      >
                        <div className="why-icon">
                          <FiCheck />
                        </div>

                        <p>{item}</p>
                      </div>
                    )
                  )}

                </div>
              </div>

            </div>
          </section>
        )}

        {/* CTA */}

        {isWhyOutcessCase &&
          study.ctaTitle && (
            <section className="case-detail-cta">
              <div className="case-detail-container container ">

                <h2>
                  {study.ctaTitle}
                </h2>

                {study.ctaDescription && (
                  <p>
                    {
                      study.ctaDescription
                    }
                  </p>
                )}

                <button className="ccsnl-btn">
                  <NavLink
                    to="/contact-us"
                    className="text-white"
                  >
                    Book a Demo
                  </NavLink>
                </button>



              </div>
            </section>
          )}

        {/* FORM ONLY FOR STANDARD */}

        {!isWhyOutcessCase && (
          <RequestQuote title="BOOK A DEMO" />
        )}
      </div>

      <Footer />
    </>
  );
};

export default CaseStudyDetails;